import http from './http';
import socket from './socket';
import root from './root';
import accessTokens from './access-tokens';
import users from './users';
import projects from './projects';
import boards from './boards';
import folders from './folders';
import labels from './labels';
import lists from './lists';
import cards from './cards';
import cardMemberships from './card-memberships';
import cardLabels from './card-labels';
import attachments from './attachments';
import activities from './activities';
import commentActivities from './comment-activities';
import notifications from './notifications';
import cardRelations from './card-relations';
import userRoleAssignments from './user-role-assignments';

export { http, socket };

export default {
  ...root,
  ...accessTokens,
  ...users,
  ...projects,
  ...boards,
  ...folders,
  ...labels,
  ...lists,
  ...cards,
  ...cardMemberships,
  ...cardLabels,
  ...attachments,
  ...activities,
  ...commentActivities,
  ...notifications,
  ...cardRelations,
  ...userRoleAssignments,
};
